// schemas/formSchema.ts
import { z } from 'zod';

export const formSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(3, 'Name must be at least 3 characters long'),
    description: z.string().optional(),
    status: z.enum(['published', 'archived']).default('published')
});
